import type { GAEventPayload } from "rivals/shared/analytics";

export enum GAActions {
  SEND_GA_EVENT = "SEND_GA_EVENT"
}

export const sendGAEvent = (event: GAEventPayload) =>
  ({ payload: event, type: GAActions.SEND_GA_EVENT } as const);
